const KahlerLogo = ({ isCollapsed }: { isCollapsed: boolean }) =>
  <div data-testid="logo-container" className="d-flex justify-content-center">
    <a href="https://www.kahlerautomation.com" target="_blank" rel="noreferrer" aria-label="Logo" title="Kahler Automation">
      <img className={`m-2${isCollapsed ? '' : ' d-none'}`} src="/images/KA-RGB-color_logo-minimized.png" alt="Minimized Logo" style={{ width: '3.5rem' }} />
      <img className={`m-2${isCollapsed ? ' d-none' : ''}`} src="/images/KA-RGB-color_logo.png" alt="Logo" width='100' style={{ minWidth: '15rem', maxWidth: '15rem' }} />
    </a>
  </div>;

export { KahlerLogo };
